import { render, staticRenderFns } from "./WebCategories.vue?vue&type=template&id=bd9278ea"
import script from "./WebCategories.vue?vue&type=script&lang=js"
export * from "./WebCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports